var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page f-2 report-page" }, [
    _c(
      "div",
      { staticClass: "report-area" },
      [
        _vm._l(_vm.reportsList, function (item) {
          return [
            _c("reportBox", { key: item.id, attrs: { reportInfo: item } }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }